import { get } from "lodash";
import serverCall from "../serverCall";

const login = async (userSignInRequest) => {
  const { email, password, code } = userSignInRequest;
  // Let errors propagate to the caller (the thunk) so failures show a real message
  // instead of crashing on an undefined response.
  const response = await serverCall.post(`/auth/login`, { email, password, code });

  const user = get(response, "data.apiresponse.data", null);
  const token = user?.token;
  if (!token) {
    throw new Error("Unexpected response from server.");
  }

  const userAndToken = { user: user.email, token, email };
  localStorage.setItem("twinbox-admin-store", JSON.stringify(userAndToken));
  return userAndToken;
};

const logout = () => {
  localStorage.removeItem("twinbox-admin-store");
  localStorage.removeItem("isLoggedIn");
};

const AuthenticationService = {
  login,
  logout,
};

export default AuthenticationService;
